<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>科研成果</h1>
        <p>探索创新，追求卓越</p>
      </div>
    </div>

    <div class="research-container">
      <!-- 介绍部分 -->
      <div class="research-intro">
        <h2>我们的研究成果</h2>
        <p>
          人工智能与机器人实验室在多个研究领域取得了丰硕的成果，包括高水平学术论文、科研项目、专利技术和科研奖项。以下是我们的主要科研成果展示。
        </p>
      </div>

      <!-- Tabs -->
      <div class="research-tabs">
        <div
            class="research-tab"
            :class="{ active: activeTab === 'publications' }"
            @click="activeTab = 'publications'"
        >
          学术论文
        </div>
        <div
            class="research-tab"
            :class="{ active: activeTab === 'projects' }"
            @click="activeTab = 'projects'"
        >
          科研项目
        </div>
        <div
            class="research-tab"
            :class="{ active: activeTab === 'patents' }"
            @click="activeTab = 'patents'"
        >
          专利成果
        </div>
        <div
            class="research-tab"
            :class="{ active: activeTab === 'awards' }"
            @click="activeTab = 'awards'"
        >
          科研获奖
        </div>
        <div
            class="research-tab"
            :class="{ active: activeTab === 'videos' }"
            @click="activeTab = 'videos'"
        >
          成果视频
        </div>
      </div>


      <!-- 内容区域 -->
      <div class="research-content">
        <!-- 学术论文 -->
        <div v-if="activeTab === 'publications'" class="publication-list">
          <div
              class="publication-item"
              v-for="(paper, index) in publications"
              :key="index"
          >
            <div class="item-image">
              <img
                  v-if="paper.cover"
                  :src="paper.cover"
                  alt="论文封面"
              />
              <span v-else>论文封面</span>
            </div>
            <div class="item-content">
              <div
                  class="publication-title"
                  @click="showPDF(paper.file, paper.title)"
              >
                {{ paper.title }}
              </div>
              <div class="publication-authors">{{ paper.authors }}</div>
              <div class="publication-journal">{{ paper.journal }}</div>
              <div class="publication-doi">{{ paper.doi }}</div>
              <div class="publication-abstract">{{ paper.abstract }}</div>
            </div>
          </div>
          <a href="#" class="view-more">查看更多论文 →</a>
        </div>

        <!-- 科研项目 -->
        <div v-if="activeTab === 'projects'" class="project-list">
          <div
              class="project-item"
              v-for="(project, index) in projects"
              :key="index"
          >
            <div class="item-image">
              <img
                  v-if="project.cover"
                  :src="project.cover"
                  alt="项目图片"
              />
              <span v-else>项目图片</span>
            </div>
            <div class="item-content">
              <div
                  class="project-title"
                  @click="showPDF(project.file, project.title)"
              >
                {{ project.title }}
              </div>
              <div class="project-team">{{ project.team }}</div>
              <div class="project-source">{{ project.source }}</div>
              <div class="project-period">{{ project.period }}</div>
              <div class="project-desc">{{ project.desc }}</div>
            </div>
          </div>
          <a href="#" class="view-more">查看更多项目 →</a>
        </div>

        <!-- 专利成果 -->
        <div v-if="activeTab === 'patents'" class="patent-list">
          <div
              class="patent-item"
              v-for="(patent, index) in patents"
              :key="index"
          >
            <div class="item-image">
              <img
                  v-if="patent.certificate"
                  :src="patent.certificate"
                  alt="专利证书"
              />
              <span v-else>专利证书</span>
            </div>
            <div class="item-content">
              <div class="patent-title" @click="showPDF(patent.file, patent.title)">{{ patent.title }}</div>
              <div class="patent-number">{{ patent.number }}</div>
              <div class="patent-inventors">{{ patent.inventors }}</div>
              <div class="patent-date">{{ patent.date }}</div>
              <div class="patent-abstract">{{ patent.abstract }}</div>
            </div>
          </div>
          <a href="#" class="view-more">查看更多专利 →</a>
        </div>

        <!-- 科研获奖 -->
        <div v-if="activeTab === 'awards'" class="award-list">
          <div class="award-item" v-for="(award, index) in awards" :key="index">
            <div class="item-image">
              <img
                  v-if="award.certificate"
                  :src="award.certificate"
                  alt="获奖证书"
              />
              <span v-else>获奖证书</span>
            </div>
            <div class="item-content">
              <div class="award-title" @click="showPDF(award.file, award.title)">{{ award.title }}</div>
              <div class="award-year">{{ award.year }}</div>
              <div class="award-recipients">{{ award.recipients }}</div>
              <div class="award-org">{{ award.org }}</div>
              <div class="award-desc">{{ award.desc }}</div>
            </div>
          </div>
          <a href="#" class="view-more">查看更多奖项 →</a>
        </div>

        <!-- 成果视频 -->
        <div v-if="activeTab === 'videos'" class="video-list">
          <div
              class="video-item"
              v-for="(video, index) in videos"
              :key="index"
          >
            <div class="item-image">
              <img
                  v-if="video.cover"
                  :src="video.cover"
                  alt="视频封面"
              />
              <span v-else>视频封面</span>
            </div>
            <div class="item-content">
              <div
                  class="project-title"
                  @click="showVideo(video.file, video.title)"
              >
                {{ video.title }}
              </div>
              <div class="project-period">{{ video.year }}</div>
              <div class="project-desc">{{ video.desc }}</div>
            </div>
          </div>
          <a href="#" class="view-more">查看更多视频 →</a>
        </div>
      </div>
      <!-- 弹窗（PDF Modal） -->
      <div v-if="pdfVisible" class="pdf-modal">
        <div class="pdf-modal-content">
          <div class="pdf-modal-header">
            <h3>{{ pdfTitle }}</h3>
            <span class="close-btn" @click="pdfVisible = false">×</span>
          </div>
          <div class="pdf-modal-body">
            <iframe :src="pdfFile" width="100%" height="600px" frameborder="0"></iframe>
          </div>
        </div>
      </div>

      <!-- 弹窗（Video Modal） -->
      <div v-if="videoVisible" class="pdf-modal">
        <div class="pdf-modal-content">
          <div class="pdf-modal-header">
            <h3>{{ videoTitle }}</h3>
            <span class="close-btn" @click="closeVideo">×</span>
          </div>
          <div class="pdf-modal-body">
            <video
                ref="videoPlayer"
                :key="videoFile"
                width="100%"
                height="600"
                controls
                controlslist="nodownload"
                crossorigin="anonymous"
            >
              <source :src="videoFile" type="video/mp4"/>
              您的浏览器不支持视频播放。
            </video>
          </div>
        </div>
      </div>


    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import {
  PublicationList,
  ProjectList,
  PatentList,
  PwardList,
  VideoList,
} from "../../api/research";


export default {
  name: "ResearchPage",
  components: {Header, Nav, Footer},
  data() {
    return {
      activeTab: "publications",
      pdfVisible: false, // 控制 PDF 弹窗显示
      pdfFile: "", // 当前 PDF 地址
      pdfTitle: "", // 当前标题
      videoVisible: false, // 控制视频弹窗显示
      videoFile: "", // 当前视频地址
      videoTitle: "", // 当前视频标题
      publications: [],
      projects: [],
      patents: [],
      awards: [

        {
          title: "国家自然科学二等奖：新型智能材料设计与应用",
          year: "2025年",
          recipients: "获奖人：张明远，李华，王建国等",
          org: "授奖单位：中华人民共和国国务院",
          desc: "该奖项表彰了我们在新型智能材料设计与应用方面的系统性创新成果。我们开发的多项智能材料技术已在实际应用中取得显著成效。",
          certificate: "",
          file: "",
        },
        {
          title: "教育部自然科学一等奖：二维功能材料与器件",
          year: "2024年",
          recipients: "获奖人：张明远，赵雪，孙伟等",
          org: "授奖单位：中华人民共和国教育部",
          desc: "该奖项表彰了我们在二维功能材料与器件研究方面的突出贡献。我们开发的多种二维材料器件在传感、能源等领域具有重要应用价值。",
          certificate: "",
          file: "",
        },
        {
          title: "中国材料研究学会科学技术奖",
          year: "2023年",
          recipients: "获奖人：王建国，钱学森等",
          org: "授奖单位：中国材料研究学会",
          desc: "该奖项表彰了我们在自修复材料研究方面的创新成果。我们开发的自修复纳米复合材料在多个领域展现出广阔应用前景。",
          certificate: "",
          file: "",
        },
      ],
    };
  },
  methods: {
    showPDF(file, title) {
      console.log("输出", file);
      // 如果未上传 PDF，则给出提示，不打开弹窗
      if (!file) {
        alert("该成果暂未上传 PDF 文件");
        return;
      }
      this.pdfFile = file;
      this.pdfTitle = title;
      this.pdfVisible = true;
    },
    // 处理文件URL，确保正确拼接后端地址
    formatFileUrl(url) {
      if (!url || !url.trim() || url.trim() === "/") {
        return "";
      }
      // 如果已经是完整URL
      if (/^https?:\/\//.test(url)) {
        // 将http转换为https
        return url.replace(/^http:\/\//, "https://");
      }
      
      // 相对路径，拼接后端地址
      return `https://localhost:8090/${url.replace(/^\/+/, "")}`;
    },
    async getPublicationList() {
      let res = await PublicationList();
      if (res.code === 0) {
        let publicationsData = res.rows;
        for (let i = 0; i < publicationsData.length; i++) {
          this.publications.push({
            title: publicationsData[i].title,
            authors: publicationsData[i].authorsInventorsRecipients,
            journal: publicationsData[i].organizationSource,
            doi: publicationsData[i].doi,
            abstract: publicationsData[i].description,
            file: this.formatFileUrl(publicationsData[i].pdfUrl),
            cover: publicationsData[i].imageUrl,
          });
        }
      }
    },

    async getProjectList() {
      let res = await ProjectList();
      if (res.code === 0) {
        let projectsData = res.rows;
        for (let i = 0; i < projectsData.length; i++) {
          this.projects.push({
            title: projectsData[i].title,
            team: projectsData[i].authorsInventorsRecipients,
            source: projectsData[i].organizationSource,
            period: projectsData[i].achievementYear,
            desc: projectsData[i].description,
            file: this.formatFileUrl(projectsData[i].pdfUrl),
            cover: projectsData[i].imageUrl,
          });
        }
      }
    },

    async getPatentList() {
      let res = await PatentList();
      if (res.code === 0) {
        let patentsData = res.rows;
        for (let i = 0; i < patentsData.length; i++) {
          this.patents.push({
            title: patentsData[i].title,
            number: patentsData[i].patentNumber,
            inventors: patentsData[i].authorsInventorsRecipients,
            date: patentsData[i].achievementYear,
            abstract: patentsData[i].description,
            certificate: patentsData[i].certificateUrl,
            file: this.formatFileUrl(patentsData[i].pdfUrl),
          });
        }
      }
    },
    async getPwardList() {
      let res = await PwardList();
      if (res.code === 0) {
        let pwardsData = res.rows;
        for (let i = 0; i < pwardsData.length; i++) {
          this.awards.push({
            title: pwardsData[i].title,
            year: pwardsData[i].achievementYear,
            recipients: pwardsData[i].authorsInventorsRecipients,
            org: pwardsData[i].organizationSource,
            desc: pwardsData[i].description,
            certificate: pwardsData[i].certificateUrl,
            file: this.formatFileUrl(pwardsData[i].pdfUrl),
          });
        }
      }
    },
    async getVideoList() {
      let res = await VideoList();
      if (res.code === 0) {
        let videosData = res.rows;
        this.videos = [];
        for (let i = 0; i < videosData.length; i++) {
          this.videos.push({
            title: videosData[i].title,
            year: videosData[i].achievementYear,
            desc: videosData[i].description,
            file: this.formatFileUrl(videosData[i].videoUrl),
            cover: videosData[i].imageUrl,
          });
        }
      }
    },
    showVideo(file, title) {
      console.log("输出视频点击", file)
      if (!file) {
        alert("该成果暂未上传视频文件");
        return;
      }
      this.videoFile = file;
      this.videoTitle = title;
      this.videoVisible = true;
    },
    closeVideo() {
      // 停止视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
      this.videoVisible = false;
      this.videoFile = "";
    },

  },
  mounted() {
    this.getPublicationList();
    this.getProjectList();
    this.getPatentList();
    this.getPwardList();
    this.getVideoList();
  },
};
</script>


<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}

.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.1em;
}

.research-container {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.research-intro {
  text-align: center;
}

.research-intro h2 {
  color: #003366;
  font-size: 1.8em;
  margin-bottom: 20px;
}

.research-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.research-tab {
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.research-tab.active {
  color: #004080;
  border-bottom: 2px solid #004080;
  font-weight: bold;
}

.item-image {
  width: 120px;
  height: 160px;
  background-color: #e0e0e0;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  overflow: hidden;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.publication-item,
.project-item,
.patent-item,
.award-item,
.video-item {

  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* 动画过渡 */
  background-color: #fff; /* 可加背景色，突出上浮效果 */
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 默认阴影 */
}

.publication-item:hover,
.project-item:hover,
.patent-item:hover,
.award-item:hover,
.video-item:hover {

  transform: translateY(-8px); /* 上浮 8px */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2); /* 加深阴影 */
}

.publication-title,
.project-title,
.patent-title,
.award-title {
  font-weight: bold;
  color: #003366;
  margin-bottom: 10px;
  font-size: 1.1em;
  cursor: pointer;
  transition: color 0.3s;
}

.publication-title:hover,
.project-title:hover,
.patent-title:hover,
.award-title:hover {
  color: #0066cc;
  text-decoration: underline;
}

.item-content {
  flex: 1;
}

.view-more {
  display: block;
  text-align: center;
  margin: 20px auto 0;
  color: #004080;
  text-decoration: none;
  font-weight: bold;
}

.view-more:hover {
  text-decoration: underline;
}

.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.pdf-modal-content {
  background: #fff;
  width: 80%;
  max-width: 1000px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pdf-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.pdf-modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  cursor: pointer;
  font-size: 24px;
}

.pdf-modal-body {
  padding: 0;
}
</style>
